import { Dispatch, SetStateAction, useState } from 'react'

type TemporaryDataState =
    | 'well'
    | 'intervention'
    | 'section'
    | 'rigtable'
    | 'run'
    | 'cementplug'
    | 'tubulartype'
    | 'pipemomvement'
    | 'connection'
    | 'rop'

export type TemporaryDataType = {
    wells: WellDto[]
    interventions: InterventionsDto[]
    sections: SectionDto[]
    rigTables: RigTableDto[]
    runs: RunDto[]
    cements: CementedPlugDto[]
    tubulars: TubularTypeDto[]
    pipeMovements: TubularRestrictedPipeMovementsDto[]
    connections: TubularRestrictedConnectionDto[]
    rops: TubularRestrictedRopDto[]
}

export type TemporarySetDataType = {
    setWells: Dispatch<SetStateAction<WellDto[]>>
    setInterventions: Dispatch<SetStateAction<InterventionsDto[]>>
    setSections: Dispatch<SetStateAction<SectionDto[]>>
    setRigTables: Dispatch<SetStateAction<RigTableDto[]>>
    setRuns: Dispatch<SetStateAction<RunDto[]>>
    setCements: Dispatch<SetStateAction<CementedPlugDto[]>>
    setTubulars: Dispatch<SetStateAction<TubularTypeDto[]>>
    setPipeMovements: Dispatch<SetStateAction<TubularRestrictedPipeMovementsDto[]>>
    setConnections: Dispatch<SetStateAction<TubularRestrictedConnectionDto[]>>
    setRops: Dispatch<SetStateAction<TubularRestrictedRopDto[]>>
}

function useTemporaryData() {
    const [wells, setWells] = useState<WellDto[]>([])
    const [interventions, setInterventions] = useState<InterventionsDto[]>([])
    const [sections, setSections] = useState<SectionDto[]>([])
    const [rigTables, setRigTables] = useState<RigTableDto[]>([])
    const [runs, setRuns] = useState<RunDto[]>([])
    const [cements, setCements] = useState<CementedPlugDto[]>([])
    const [tubulars, setTubulars] = useState<TubularTypeDto[]>([])
    const [pipeMovements, setPipeMovements] = useState<TubularRestrictedPipeMovementsDto[]>([])
    const [connections, setConnections] = useState<TubularRestrictedConnectionDto[]>([])
    const [rops, setRops] = useState<TubularRestrictedRopDto[]>([])

    const data: TemporaryDataType = {
        wells,
        interventions,
        sections,
        rigTables,
        runs,
        cements,
        tubulars,
        pipeMovements,
        connections,
        rops
    }

    const setData: TemporarySetDataType = {
        setWells,
        setInterventions,
        setSections,
        setRigTables,
        setRuns,
        setCements,
        setTubulars,
        setPipeMovements,
        setConnections,
        setRops
    }

    return { data, setData }
}

export default useTemporaryData
